import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import Strings from "src/shared/Strings";
var StateType;
(function (StateType) {
    StateType["NOT_LAUNCHED"] = "NOT_LAUNCHED";
    StateType["LIVE"] = "LIVE";
    StateType["PAUSED"] = "PAUSED";
    StateType["ENDED"] = "ENDED";
    StateType["STOPPED"] = "STOPPED";
})(StateType || (StateType = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignStatusPill',
    props: {
        state: {}
    },
    setup(__props) {
        const STATE_MESSAGE = {
            [StateType.NOT_LAUNCHED]: `Does not accept traffic, approve rewards, nor display creative except for in the Extole interface.`,
            [StateType.LIVE]: `Supports all events, and has normal rewarding, sharing, and analytics.`,
            [StateType.PAUSED]: `Program is closed to new advocates. Friends can continue to participate by clicking share links, using codes, getting rewarded and converting.`,
            [StateType.ENDED]: `Program is closed to advocates and friends. Any pending rewards will be processed and traffic flows to the live campaign in the program.`,
            [StateType.STOPPED]: `Does not accept traffic, approve rewards, nor display creative.`,
        };
        const props = __props;
        const campaignStateClass = computed(() => {
            return `status-pill--${Strings.convertToClassName(props.state)}`;
        });
        const message = computed(() => {
            return STATE_MESSAGE[props.state] || "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["status-pill", campaignStateClass.value])
            }, [
                _createVNode(Tooltip, {
                    message: message.value,
                    triggerType: 'inherit'
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(Strings).capitalize(_ctx.state)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["message"])
            ], 2 /* CLASS */));
        };
    }
});
